import { render, staticRenderFns } from "./EmptyShelf.vue?vue&type=template&id=7090feb3&scoped=true&"
import script from "./EmptyShelf.vue?vue&type=script&lang=js&"
export * from "./EmptyShelf.vue?vue&type=script&lang=js&"
import style0 from "./EmptyShelf.vue?vue&type=style&index=0&id=7090feb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7090feb3",
  null
  
)

export default component.exports